/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateJobPositionLevelCommand
 */
export interface UpdateJobPositionLevelCommand {
    /**
     * 
     * @type {string}
     * @memberof UpdateJobPositionLevelCommand
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateJobPositionLevelCommand
     */
    description?: string | null;
}

/**
 * Check if a given object implements the UpdateJobPositionLevelCommand interface.
 */
export function instanceOfUpdateJobPositionLevelCommand(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UpdateJobPositionLevelCommandFromJSON(json: any): UpdateJobPositionLevelCommand {
    return UpdateJobPositionLevelCommandFromJSONTyped(json, false);
}

export function UpdateJobPositionLevelCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateJobPositionLevelCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}

export function UpdateJobPositionLevelCommandToJSON(value?: UpdateJobPositionLevelCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'description': value.description,
    };
}

